import {
  EDITING_DOCUMENT__FILE_LOAD_REQUEST,
  EDITING_DOCUMENT__FILE_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

type EditingDocumentUrlState = string;

const initialState: EditingDocumentUrlState = '';

export default function reducer(
  state: EditingDocumentUrlState = initialState,
  action: EditingDocumentAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FILE_LOAD_REQUEST:
      return initialState;
    case EDITING_DOCUMENT__FILE_LOAD_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
